/** Parse the JWT from localStorage to extract the user's UUID */
export const getUserUuid = () => {
  try {
    const token = localStorage.getItem("user");
    if (!token) return null;
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    // Handle base64url encoding (replace - with +, _ with /)
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64));
    return payload.uuid || payload.public_id || payload.sub || null;
  } catch {
    return null;
  }
};

export const isValidUUID = (id) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);

export const isValidThreadId = isValidUUID;

/**
 * Check if a user is in a like/dislike/catalog array.
 * If uid is available, checks membership. Otherwise treats non-empty arrays as true.
 */
export const isUserInArray = (arr, uid) => {
  if (!Array.isArray(arr) || arr.length === 0) return false;
  if (uid) return arr.includes(uid);
  return true; // fallback: non-empty array means the current user interacted
};
